import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Spinner } from "@chakra-ui/react";
import { inspireYellow } from "@inspire/ui/static";
// This exists because default props in the theme don't seem to work with Spinner
var InspireSpinner = function(spinnerProps) {
    return /*#__PURE__*/ _jsx(Spinner, _object_spread({
        speed: "0.5s",
        color: inspireYellow,
        emptyColor: "#444"
    }, spinnerProps));
};
export default InspireSpinner;
